import React from 'react';
import PropTypes from 'prop-types';
import { Form, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import DatePicker from '../../../common/forms/input/DatePicker';
import FormFooter from '../../../common/forms/FormFooter';
import { isRequired } from '../../../../utils/validators';
import AgencySelect from '../../../common/forms/select/AgencySelect';
import CostCenterSelect from '../../../common/forms/select/CostCenterSelect';
import ChartOfAccountSelect from '../../../common/forms/select/ChartOfAccountSelect';
import VoucherTypeMigrationSelect from './VoucherTypeMigrationSelect';
import ExpenseTypeSelect from '../../../common/forms/select/ExpenseTypeSelect';

export const ExpenseSapMigrationForm = ({ handleSubmit, onCancel }) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Nombre Socio de Negocio" required>
        <Field
          name="agencyId"
          component={AgencySelect}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>

    <FormGroup row>
      <FormItem label="Centro de Costo de Gasto" required>
        <Field
          name="costCenterId"
          component={CostCenterSelect}
          type="text"
          placeholder="Centro de Costos"
          validate={[isRequired]}
          showCostCenterCode
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
  <FormItem label="Tipo de egreso">
    <Field
      name="expenseTypeName"
      component={ExpenseTypeSelect}
      isClearable={false}
    />
  </FormItem>
</FormGroup>

    <FormGroup row>
      <FormItem label="Fecha de Emisión" required>
        <Field
          name="issueDate"
          component={DatePicker}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>

    <FormGroup row>
      <FormItem label="Tipo de Comprobante">
        <Field
          name="voucherTypeId"
          component={VoucherTypeMigrationSelect}
          isClearable={false}
        />
      </FormItem>
    </FormGroup>

    <FormGroup row>
      <FormItem label="Serie" required>
        <Field
          name="documentSeries"
          component={TextInput}
          placeholder="0001"
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Correlativo" required>
        <Field
          name="documentCode"
          component={TextInput}
          placeholder="45208"
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>

    <FormGroup row>
      <FormItem label="Ruc">
        <Field
          name="businessTaxId"
          component={TextInput}
          placeholder="Ingrese RUC"
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Nombre de Proveedor">
        <Field
          name="businessName"
          component={TextInput}
          placeholder="Razón Social del Proveedor"
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Descripción">
        <Field
          name="description"
          component={TextInput}
          placeholder="Descripción"
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Importe total">
        <Field
          name="totalAmount"
          component={TextInput}
          placeholder="Importe total"
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
  <FormItem label="Cuenta Contable">
    <Field
      name="sysCode"
      component={ChartOfAccountSelect}
    />
  </FormItem>
</FormGroup>
    <FormFooter onCancel={onCancel} saveButtonText="Actualizar" />
  </Form>
);

ExpenseSapMigrationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const formComponent = reduxForm({
  form: 'ExpenseSapMigrationForm',
  enableReinitialize: true,
})(ExpenseSapMigrationForm);

export default connect(null)(formComponent);
